import React, { useState, useContext, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { PencilSquare, XSquare } from 'react-bootstrap-icons';
import { CoreContext } from '../context/core-context';
import { AuthContext } from '../context/auth-context';
import { Badge, Form } from 'react-bootstrap';
import Input from './common/Input';
import MyModal from './common/MyModal';


const LocalAreas = (props) => {
    const coreContext = useContext(CoreContext);
    const authContext = useContext(AuthContext);


    const { register, handleSubmit, errors } = useForm({
        mode: 'onSubmit',
        reValidateMode: 'onBlur',
    });

    const [name, setName] = useState('');
    const [stateId, setStateId] = useState('');
    const [districtId, setDistrictId] = useState('');
    const [countryId, setCountryId] = useState('');
    const [mode, setMode] = useState('create');
    const [disabled, setDisabled] = useState(true);
    const [editCat, setEditCat] = useState({});
    const [categoryTitle, setCategoryTitle] = useState('Add Local Area');
    const [showModal, setShowModal] = useState(false);
    const [modalBody, setModalBody] = useState('');

    const fetchLocalAreas = (e) => {
        coreContext.fetchLocalAreas(authContext.itemId);
    }

    useEffect(fetchLocalAreas, []);

    const onNameChangedHandler = (e) => {
        setName(e.target.value);
        if (e.target.value) setDisabled(false);
        else setDisabled(true);
    }

    const onCountryChangedHandler = (e) => {
        setCountryId(e.target.value);
        coreContext.fetchStates(e.target.value);
        if (e.target.value) setDisabled(false);
        else setDisabled(true);
    }

    const onStateChangedHandler = (e) => {
        setStateId(e.target.value);
        coreContext.fetchDistricts(countryId, e.target.value);
        if (e.target.value) setDisabled(false);
        else setDisabled(true);
    }

    const onDistrictChangedHandler = (e) => {
        setDistrictId(e.target.value);
        if (e.target.value) setDisabled(false);
        else setDisabled(true);

    }

    const loadLoactionOptions = () => {
        coreContext.fetchCountries();
    }

    useEffect(loadLoactionOptions, []);


    const renderCreatUpdateButtons = () => {

        if (mode === 'create') {
            return <Input value='Add' disabled={disabled} elementType='button' variant='primary' />
        } else if (mode === 'edit') {
            return <Input value='Edit' disabled={disabled} elementType='button' variant='dark' />
        }
    }

    const handleModalOpen = (cat) => {
        setShowModal(true);
        setMode('create');
        setName('');
        setEditCat(cat);
        setModalBody(cat.area_name + ' will be deleted permanently !');
    }
    const handleModalClose = () => {
        setShowModal(false);
    }

    const handleModalSubmit = (id) => {
        deleteLocalArea(id);
        setShowModal(false);
    }

    const cancelUpdate = () => {
        setMode('create');
        setName('');
        setEditCat({});
        setCategoryTitle('Add Local Area');
    }

    const renderCancelUpdateButton = () => {

        if (mode === 'create') {
            return '';
        } else if (mode === 'edit') {
            return <Input value='Cancel Edit' elementType='button' variant='warning' type='button' onClick={cancelUpdate} />
        }
    }

    const onSubmit = () => {
        if (mode === 'create') addLocalArea();
        else if (mode === 'edit') editLocalArea();
    }


    const editName = (cat) => {
        setName(cat.area_name);

        coreContext.fetchStates(cat.countryId);
        coreContext.fetchDistricts(cat.countryId, cat.stateId);

        setDistrictId(cat.districtId);
        setStateId(cat.stateId);
        setCountryId(cat.countryId);
        setMode('edit');
        setDisabled(true);
        setEditCat(cat);
        coreContext.setMessage('');
        setCategoryTitle('Edit Local Area');
    }

    const deleteLocalArea = (id) => {
        coreContext.deleteLocalArea(id, coreContext.itemId);
        setEditCat({});
    }

    const addLocalArea = () => {
        coreContext.addLocalArea(name, districtId, stateId, countryId, authContext.itemId);
        setName('');
    }
    const editLocalArea = () => {
        coreContext.editLocalArea(name, districtId, stateId, countryId, authContext.itemId, editCat.id);
        setEditCat({});
        setMode('create');
    }

    const renderLocalAreas = () => {
        if (coreContext.localAreas) {
            return coreContext.localAreas.map((cat, index) => (
                <tr key={++index}>
                    <td>{index}</td>
                    <td>{cat.area_name}</td>
                    <td><button onClick={() => editName(cat)} type="button" className="btn btn-success btn-sm" title="Edit Local Area"><PencilSquare size="12" /></button>&nbsp;&nbsp;&nbsp;<button onClick={() => handleModalOpen(cat)} type="button" className="btn btn-danger btn-sm" title="Delete Local Area"><XSquare size="12" /></button></td>
                </tr>
            ));
        }
        else {
            return (<tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>)
        }
    }

    return (
        <div className="row">
            <div className='col-md-4'>
                <div className="card" style={{ position: 'sticky', top: '50px' }}>
                    <div className="card-title mx-auto">
                        <h3>
                            <Badge variant="success">{categoryTitle}</Badge>
                        </h3>
                    </div>
                    <div className="card-body">
                        <Form autoComplete='off' onSubmit={handleSubmit(onSubmit)} noValidate>
                            <Input label='Name' name='name' value={name} minLength={3} maxLength={55} required={true} register={register}
                                errors={errors} elementType='text' placeholder='Enter Local Area Name'
                                onChange={onNameChangedHandler} />

                            <Input label='Country' name='country' required={true} register={register} errors={errors} elementType='select' value={countryId} options={coreContext.countryOptions} onChange={onCountryChangedHandler} />

                            <Input label='State' name='state' required={true} register={register} errors={errors} elementType='select' value={stateId} options={coreContext.stateOptions} onChange={onStateChangedHandler} />

                            <Input label='District' name='district' required={true} register={register} errors={errors} elementType='select' value={districtId} options={coreContext.districtOptions} onChange={onDistrictChangedHandler} />


                            {renderCreatUpdateButtons()} &nbsp;&nbsp; {renderCancelUpdateButton()} &nbsp;&nbsp; {coreContext.renderLoader()}
                            <Input variant='danger' label={coreContext.message} elementType='label' />
                        </Form>
                    </div>
                </div>
            </div>
            <div className='col-md-8'>
                <div className="card">
                    <div className="card-title mx-auto">
                        <h3>
                            <Badge variant="success">Local Areas</Badge>
                        </h3>
                    </div>
                    <div className="card-body table-responsive">
                        <table className='table table-sm table-bordered'>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Name</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {renderLocalAreas()}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <MyModal handleModalClose={handleModalClose} handleModalSubmit={handleModalSubmit} showModal={showModal} modalBody={modalBody} cat={editCat} />
        </div>
    );
}


export { LocalAreas };